// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a022013c","594":"2f57706c"}[chunkId] + ".chunk.js";
};